interface ProfilePriceProps {
  hourlyRate: number
  className: string
}

export function ProfilePrice({ hourlyRate, className }: ProfilePriceProps) {
  return (
    <div className={`${className} font-normal text-[#001A3D]`}>
      <div className='flex gap-1'>
        <p>
          <span className='text-[8px]'>From</span>
          <span className='text-[10px] md:text-base'>
            {' '}
            £{hourlyRate ? hourlyRate : '??'}.00{' '}
          </span>
        </p>
        <p className='mt-[-2px] md:mt-[-7px] text-[8px]'> p/hr</p>
      </div>
    </div>
  )
}
